import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import {
  AssignorCreationFields,
  AssignorCreationRequestFields,
  AssignorFilter,
  AssignorMinimal,
  AssignorPaged,
  AssignorSummary,
} from '../../models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { cleanEmptyProps } from '../../functions/object-to-queryparams';
import { PaginationForm } from '../../models/pagination.model';
import {
  AssignorsGroupsGetAllResponse,
  AssignorsGroupsGetByIdResponse,
  AssignorsGroupsRequest,
} from '../../models/group.model';

@Injectable({
  providedIn: 'root',
})
export class AssignorService {
  private readonly API = `${environment.api_url}/cedente`;

  constructor(private http: HttpClient) {}

  getAll(filter: Partial<PaginationForm> = null): Observable<AssignorPaged> {
    return this.http.get<AssignorPaged>(`${this.API}/paged`, {
      params: cleanEmptyProps(filter),
    });
  }

  getSummary(): Observable<AssignorSummary> {
    return this.http.get<AssignorSummary>(`${this.API}/status/resumo`);
  }

  create(
    body: AssignorCreationFields
  ): Observable<AssignorCreationRequestFields> {
    return this.http.post<AssignorCreationRequestFields>(
      `${this.API}/criar`,
      body
    );
  }

  update(
    body: AssignorCreationFields
  ): Observable<AssignorCreationRequestFields> {
    return this.http.put<AssignorCreationRequestFields>(
      `${this.API}/atualizar`,
      body
    );
  }

  getById(id: number): Observable<AssignorCreationRequestFields> {
    return this.http.get<AssignorCreationRequestFields>(`${this.API}/${id}`);
  }

  assignorFilter(
    filters: AssignorFilter,
    filterPaginator: Partial<PaginationForm> = null
  ): Observable<AssignorPaged> {
    return this.http.post<AssignorPaged>(`${this.API}/filter`, filters, {
      params: cleanEmptyProps(filterPaginator),
    });
  }

  getAssignorsByCnpjFundo(cnpjFundo: string): Observable<AssignorMinimal[]> {
    return this.http.get<AssignorMinimal[]>(
      `${this.API}/MinimalCedente/${cnpjFundo}`
    );
  }

  createAssignorGroup(group: AssignorsGroupsRequest): Observable<void> {
    return this.http.post<void>(`${this.API}/grupos`, group);
  }

  updateAssignorGroup(group: AssignorsGroupsRequest): Observable<void> {
    return this.http.put<void>(`${this.API}/document-flows`, group);
  }
  
  deleteGroup(idGroup: number) : Observable<void> {
    return this.http.delete<void>(`${this.API}/document-flows/${idGroup}`);
  }

  getGroupsByIdCedente(
    idCedente: number
  ): Observable<AssignorsGroupsGetAllResponse> {
    return this.http.get<AssignorsGroupsGetAllResponse>(
      `${this.API}/GruposByIdCedente/${idCedente}`
    );
  }

  getGroupById(idGrupo: number): Observable<AssignorsGroupsGetByIdResponse> {
    return this.http.get<AssignorsGroupsGetByIdResponse>(
      `${this.API}/Grupos/${idGrupo}`
    );
  }
}
